import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Box } from "@mui/system";
import { GridColDef } from "@mui/x-data-grid-pro";
import SaveIcon from "@mui/icons-material/Save";
import CommonDataGridTable from "../../../../../CommonDataGridTable/CommonDataGridTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  setConfirmLoaderSTControl,
  setSelectedRowsForMissingCrossNegatives,
  setToggledNegativesForMissingCrossNegatives,
} from "../../../../../../../../../features/searchTermTabSlice";
import { setDisplayErrorSnackBar } from "../../../../../../../../../features/userSlice";
import { useSearchTermsTab } from "../../../../../STOperationhooks/useSearchTermsTab";

const NegativeDefinitionModal = ({ open, onClose }: any) => {
  const dispatch = useDispatch();
  const {
    selectedRowsForMissingCrossNegatives, // get the selected rows
    definitionModalSourceForMissingCrossNegatives,
    toggledNegativesForMissingCrossNegatives,
    confirmLoaderSTControl,
  } = useSelector((state: any) => state.searchTermTab);

  const { createNegativeSearchTermLinks, getExclusiveSTMissingNegatives } =
    useSearchTermsTab(); //custom hook to handle API calls

  // === COLUMNS ===
  const columns: GridColDef[] = [
    {
      field: "search_term",
      headerName: "Search Term",
      flex: 1,
      minWidth: 160,
    },
    {
      field: "search_term_match_type",
      headerName: "Match Type",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "no_of_adgroups",
      headerName: "Number of Negative Adgroups set with this term",
      flex: 1,
      minWidth: 200,
    },
  ];

  let mergedList = [];
  // === MERGE SELECTED ROWS WITH DEFINITIONS ===
  if (
    definitionModalSourceForMissingCrossNegatives === "headerIcon" ||
    definitionModalSourceForMissingCrossNegatives === "saveButton"
  ) {
    const dataSource =
      definitionModalSourceForMissingCrossNegatives === "headerIcon"
        ? selectedRowsForMissingCrossNegatives
        : toggledNegativesForMissingCrossNegatives;
    mergedList = dataSource.map((row: any) => ({
      id: row.id,
      search_term: row.search_term,
      keyword_name: row.keyword_name,
      keyword_id: row.keyword_id,
      search_term_match_type: row.search_term_match_type,
      campaign_id: row.campaign_id,
      campaign_name: row.campaign_name,
      adgroup_id: row.adgroup_id,
      adgroup_name: row.adgroup_name,
      ad_shared_uid: row.ad_shared_uid,
      non_negative_in_ad_group_shared_uid:
        row.non_negative_in_ad_group_shared_uid,
      scope_shared_uid: row.scope_shared_uid,
      no_of_adgroups: row.noOfAdgroupsSetWithThisTerm,
    }));
  }

  // === Negative Classification ===
  const negativeClassifySearchTermsHandler = async () => {
    dispatch(setConfirmLoaderSTControl(true));
    let totalSuccess = 0;

    try {
      // === Process Negative ===
      if (mergedList?.length > 0) {
        const negativeData = mergedList || [];
        const reqBody = {
          terms: negativeData.map((item: any) => ({
            term: item.search_term,
            match_type: item.search_term_match_type,
            level: "ad_group",
            level_shared_uid: item.non_negative_in_ad_group_shared_uid,
          })),
        };
        const { successCount } = await createNegativeSearchTermLinks(reqBody);
        totalSuccess += successCount;
      }

      // Refresh data + close Modal + claer redux if anything succeeded
      if (totalSuccess > 0) {
        await getExclusiveSTMissingNegatives();
        dispatch(setSelectedRowsForMissingCrossNegatives([])); // Clear selected rows
        dispatch(setToggledNegativesForMissingCrossNegatives([])); // Clear toggled negatives
        onClose(); // Close modal
      }
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Failed to classify search terms.";
      dispatch(
        setDisplayErrorSnackBar({
          message: `Critical error during classification: ${errorMessage}`,
          type: "error",
        })
      );
    } finally {
      dispatch(setConfirmLoaderSTControl(false));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        // Prevent close if loading and the reason is backdrop click or escape key
        if (
          // confirmLoaderUnclassifiedST &&
          reason === "backdropClick" ||
          reason === "escapeKeyDown"
        ) {
          return;
        }
        onClose();
      }}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>
        Total Number of Search Terms Set as Negative:{mergedList?.length || 0}{" "}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <CommonDataGridTable rows={mergedList} columns={columns} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "16px 20px 16px" }}>
        <Button
          disabled={confirmLoaderSTControl}
          onClick={onClose}
          color="secondary"
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          data-tracker="554"
          variant="contained"
          onClick={negativeClassifySearchTermsHandler}
          loading={confirmLoaderSTControl}
          loadingPosition="end"
          endIcon={confirmLoaderSTControl && <SaveIcon />}
          disabled={!mergedList?.length || confirmLoaderSTControl}
          color="secondary"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NegativeDefinitionModal;
